import { combineReducers } from 'redux';
import appState from './appState';
import auth from './auth';
import analyze from './analyze';
import embedCode from './embedCode';
import filters from './filters';
import requestStates from './requestsStateReducer';
import users from './users';
import preview from './preview';
import interactiveDetails from './interactiveDetails';
import modals from './modals';
import templates from './templates';
import aiGeneration from './aiGeneration';
const rootReducer = combineReducers({
  appState,
  analyze,
  auth,
  embedCode,
  filters,
  interactiveDetails,
  modals,
  preview,
  templates,
  requestStates,
  users,
  aiGeneration
});
export default rootReducer;